import { render, staticRenderFns } from "./currency-exchange-trade-helper-components-1-main-page.vue?vue&type=template&id=ba514174&"
import script from "./currency-exchange-trade-helper-components-1-main-page.vue?vue&type=script&lang=ts&"
export * from "./currency-exchange-trade-helper-components-1-main-page.vue?vue&type=script&lang=ts&"
import style0 from "./currency-exchange-trade-helper-components-1-main-page.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports